import React from 'react';
import { ImagePreview as ImagePreviewNew } from './ImagePreview';
import { convertOldImagePreviewProps } from './converter.old';
import type { OldImagePreviewProps } from './converter.old';

export type ImagePreviewProps = OldImagePreviewProps;

export const ImagePreview = React.forwardRef<HTMLImageElement, ImagePreviewProps>((props, ref) => (
  <ImagePreviewNew ref={ref} {...convertOldImagePreviewProps(props)} />
));
